var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-radio-group',{staticClass:"radio-group",attrs:{"value":_vm.value,"model":_vm.value,"rules":_vm.radioErrors()},on:{"change":function($event){return _vm.$emit('input', $event)}}},_vm._l((_vm.options),function(option){return _c('v-radio',{key:option.id,attrs:{"label":option.hint,"value":option.value,"color":'#00BFB3'}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b202b22c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/fields/Radio.vue
// module id = null
// module chunks = 